import React from 'react';
import { Link } from 'react-router-dom';
import Pagination from '../../../components/pagination';
import { format, isAfter, isBefore, isSameDay } from 'date-fns';

function VoucherTable({
  handleSort,
  onDelete,
  onSelectedData,
  paginationOptions,
  handlePageChange,
  loading,
  error,
  data,
  totalRows,
  handleRefresh
}) {
  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th className="cursor-pointer" onClick={() => handleSort('code')}>
              Kode Voucher
              {paginationOptions.sort_field === 'code' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="cursor-pointer" onClick={() => handleSort('value')}>
              Nilai
              {paginationOptions.sort_field === 'value' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            {/* <th className="cursor-pointer" onClick={() => handleSort('title_id')}>
              Judul (ID)
              {paginationOptions.sort_field === 'title_id' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="cursor-pointer" onClick={() => handleSort('title_en')}>
              Judul (EN)
              {paginationOptions.sort_field === 'title_en' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th> */}
            <th className="cursor-pointer" onClick={() => handleSort('quota')}>
              Kuota
              {paginationOptions.sort_field === 'quota' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="cursor-pointer" onClick={() => handleSort('used')}>
              Terpakai
              {paginationOptions.sort_field === 'used' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="cursor-pointer" onClick={() => handleSort('valid_from')}>
              Berlaku Mulai
              {paginationOptions.sort_field === 'valid_from' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="cursor-pointer" onClick={() => handleSort('valid_thru')}>
              Berlaku Hingga
              {paginationOptions.sort_field === 'valid_thru' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="10">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center" colSpan="10">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="10">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={handleRefresh}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td>
                <span className="fw-500">{row.code ?? '-'}</span>
              </td>
              <td>
                <span className="fw-500">{row.value ?? '-'}</span>
              </td>
              {/* <td>
                <span className="fw-500">{row.title_id ?? '-'}</span>
              </td>
              <td>
                <span className="fw-500">{row.title_en ?? '-'}</span>
              </td> */}
              <td>
                <span className="fw-500">{row.quota ?? '-'}</span>
              </td>
              <td>
                <span className="fw-500">{row.used ?? '-'}</span>
              </td>
              <td>{format(new Date(row.valid_from), 'dd/MM/yyyy')}</td>
              <td>{format(new Date(row.valid_thru), 'dd/MM/yyyy')}</td>
              <td className="text-center pe-0">
                <div
                  hidden={
                    !isBefore(new Date(row.valid_from), new Date()) &&
                    !isSameDay(new Date(row.valid_from), new Date())
                  }
                  onClick={() => onSelectedData(row)}
                  data-bs-toggle="modal"
                  data-bs-target="#viewVoucherModal"
                  className="fw-600 btn btn-success text-white btn-sm">
                  <i className="fa fa-eye mr-4"></i>
                  Detail
                </div>
                <Link
                  hidden={
                    isBefore(new Date(row.valid_from), new Date()) ||
                    isSameDay(new Date(row.valid_from), new Date())
                  }
                  to={`/voucher/detail/${row.id}`}
                  className="fw-600 btn btn-success text-white btn-sm">
                  <i className="fa fa-pencil mr-4"></i>
                  Edit
                </Link>
                <div
                  hidden={
                    isBefore(new Date(row.valid_from), new Date()) ||
                    isSameDay(new Date(row.valid_from), new Date())
                  }
                  onClick={() => onDelete(row.id)}
                  className="fw-600 btn btn-danger text-white btn-sm ml-10">
                  <i className="fa fa-trash mr-4"></i>
                  Hapus
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        currentPage={paginationOptions.page}
        totalRows={totalRows}
        rowsPerPage={paginationOptions.limit}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default VoucherTable;
